<template>
  <div class="frame-grid-collection">
    <transition
      enter-active-class="animated zoomCustomIn"
      leave-active-class="animated zoomCustomOut"
      mode="out-in"
    >
      <div class="frame-grid-collection__modal" v-show="selectedImage !== null">
        <white-close class="frame-grid-collection__modal__close" @click="closeModal()" />
        <div class="frame-grid-collection__modal__container">
          <img :src="selectedImage" />
        </div>
      </div>
    </transition>

    <div class="frame-grid-collection__container" v-if="items.length > 0">
      <sui-grid :columns="3" centered class="frame-grid-collection__three-columns">
        <sui-grid-row>
          <sui-grid-column
            class="frame-grid-collection__item"
            v-for="(item, index) in firstCell"
            :key="`${item}-${index}`"
          >
            <img :src="item" @click="setModalImage(item)" />
          </sui-grid-column>
        </sui-grid-row>
      </sui-grid>

      <sui-grid :columns="2" centered class="frame-grid-collection__two-columns">
        <sui-grid-row>
          <sui-grid-column
            class="frame-grid-collection__item"
            v-for="(item, index) in secondCell"
            :key="`${item}-${index}`"
          >
            <img :src="item" @click="setModalImage(item)" />
          </sui-grid-column>
        </sui-grid-row>
      </sui-grid>
    </div>
  </div>
</template>

<script>
import WhiteCloseSVG from "@/assets/close-white.svg";

export default {
  name: "frame-grid-collection",
  components: {
    "white-close": WhiteCloseSVG,
  },
  props: {
    items: {
      type: Array,
    },
  },

  data() {
    return {
      selectedImage: null,
    };
  },

  computed: {
    firstCell() {
      if (this.items.length > 0) {
        return [].concat(this.items[0]).concat(this.items[1]).concat(this.items[2]);
      }
      return [];
    },

    secondCell() {
      if (this.items.length > 0) {
        return [].concat(this.items[3]).concat(this.items[4]);
      }
      return [];
    },
  },

  methods: {
    setModalImage(image) {
      this.selectedImage = image;
    },

    closeModal() {
      this.selectedImage = null;
    },
  },
};
</script>

<style lang="scss">
.frame-grid-collection {
  height: auto;
  width: 100%;
  position: relative;
  padding: 20px;

  &__item {
    position: relative;

    &:hover {
      img {
        opacity: 1;
        transition: opacity 0.3s ease-in-out;
      }
    }
  }

  &__container {
    img {
      width: 100%;
      opacity: 0.9;
      transition: opacity 0.3s ease-in-out;
      cursor: pointer;
    }

    .column {
      padding: 0 10px !important;
    }
  }

  &__two-columns {
    .row {
      padding: 0 !important;
    }
  }

  &__modal {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
    left: 0;
    z-index: 10;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    &__container {
      img {
        width: 100%;
      }
    }

    &__close {
      position: absolute;
      right: 30px;
      top: 30px;
      transform: scale(0.8);
      transition: all 0.3s ease-in-out;
      cursor: pointer;

      &:hover {
        transform: scale(1);
        transition: all 0.3s ease-in-out;
      }
    }
  }
}

@media (max-width: 1000px) {
  .frame-grid-collection {
    .row {
      padding: 0 !important;

      .column {
        width: 100% !important;
        margin-bottom: 20px !important;
        padding: 0 !important;
      }
    }
  }
}
</style>
